import * as selectors from 'app/request/persistent-data-selectors';
import { types } from './products-types';

export const getCoachPayment = (state, profileId) =>
  selectors.getType(state.products, types.COACH_PAYMENT, profileId);
